module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "duplicate-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "duplicate-form"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('duplicate-form.Name')
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicateName),
      expression: "duplicateName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Name"
    },
    domProps: {
      "value": (_vm.duplicateName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duplicateName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duplicate-form.Name')),
      expression: "errors.has('duplicate-form.Name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('duplicate-form.Name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('duplicate-form.Description')
    }
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicateDesc),
      expression: "duplicateDesc"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Description"
    },
    domProps: {
      "value": (_vm.duplicateDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duplicateDesc = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duplicate-form.Description')),
      expression: "errors.has('duplicate-form.Description')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('duplicate-form.Description')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('duplicate-form.Location')
    }
  }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicateType),
      expression: "duplicateType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Location"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.duplicateType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "form"
    }
  }, [_vm._v("Form")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "template"
    }
  }, [_vm._v("Template")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duplicate-form.Location')),
      expression: "errors.has('duplicate-form.Location')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('duplicate-form.Location')))])]), _vm._v(" "), (_vm.duplicateType == 'form') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('duplicate-form.Related')
    }
  }, [_c('label', [_vm._v("Related to")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicateModule),
      expression: "duplicateModule"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Related"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.duplicateModule = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredModules), function(module) {
    return _c('option', {
      domProps: {
        "value": module.key
      }
    }, [_vm._v(_vm._s(module.name) + "\n                                    ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duplicate-form.Related')),
      expression: "errors.has('duplicate-form.Related')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('duplicate-form.Related')))])]) : _vm._e(), _vm._v(" "), (_vm.duplicateModule == 'organization_organization' || _vm.duplicateModule == 'organization_general') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('duplicate-form.User Access')
    }
  }, [_c('label', [_vm._v("User access")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duplicateAccessLevel),
      expression: "duplicateAccessLevel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "User Access"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.duplicateAccessLevel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.accessLevels), function(accessLevel) {
    return _c('option', {
      domProps: {
        "value": accessLevel.key
      }
    }, [_vm._v(_vm._s(accessLevel.name) + "\n                                    ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duplicate-form.User Access')),
      expression: "errors.has('duplicate-form.User Access')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('duplicate-form.User Access')))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button duplicated-btn",
    attrs: {
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.runDuplicate.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Add Form")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("DUPLICATE FORM SETTINGS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1603f3d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/modals/DuplicateFormModal.vue
// module id = 1565
// module chunks = 1